import { mapState } from 'vuex';
export default {
  name: 'MonitoringDisableDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOption: 'disable'
    };
  },
  computed: {
    ...mapState('app', ['color']),
    internalOpen: {
      get() {
        return this.open;
      },
      set(val) {
        if (!val) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', this.selectedOption === 'delete');
    },
    cancel() {
      this.$emit('close');
      this.selectedOption = 'disable';
    }
  }
};